import React from 'react';
import { registerSidebar } from '../../../Common/SidebarPlugin/SidebarContext';
import { useAskAISidebar } from './hooks/useAskAISidebar';

export const registerAiSidebar = () => {
  registerSidebar(
    'ask-ai',
    React.lazy(() => import('./AskAISidebarContent')),
    {
      Rail: React.lazy(() => import('./AskAISidebarRail')),
      useSharedState: useAskAISidebar,
      hideContainerControls: true,
    }
  );
};
